import { client } from "api";

export type DeleteCompanyRequest = {
  companyId: string;
};

export type DeleteCompanyResponse = string;

export const deleteCompany = (request: DeleteCompanyRequest): Promise<DeleteCompanyResponse> =>
  client.delete<DeleteCompanyResponse>(`/company/${request.companyId}`).then((res) => res.data);
